import { Component, OnInit } from '@angular/core';
import { IdeaWord } from '../../models';
import { TileService, WordOfTheWeek } from '../../../widgets/services/tile.service';

@Component({
  selector: 'app-ideaword',
  standalone: true,
  imports: [],
  templateUrl: './ideaword.component.html',
  styleUrl: './ideaword.component.scss'
})
//export class IdeawordComponent {
//  ideaword: IdeaWord = {
//    word: 'Word of the Month: Heritage',
//    definition: 'The world is currently facing significant challenges, and it can be hard to feel like we, as individuals, can make a positive impact. Even as we focus on our work serving as trusted advisors to our clients, we can continue to recognize and celebrate our differences, acting with empathy and kindness. One way we can do this is by understanding we each have our own <strong>heritage</strong> – this month’s Word of the Month – and how important it is that we get to better know, understand, work with and be kind to each other.'
//  }


//  }

//TODO: Retrieve ideaword from api

  export class IdeawordComponent implements OnInit {

    constructor(private tileService: TileService) { }
    wordOfTheWeek: WordOfTheWeek = {
      word: '',
      details:''
    };
    ngOnInit(): void {
      this.getWordfTheWeek();
    }
    getWordfTheWeek() {

      this.tileService.getcurrentWordOfTheWeek().then((data) => {
        var list: WordOfTheWeek[] = [];
        list = data;
        this.wordOfTheWeek.word = list[0].word;
        this.wordOfTheWeek.details = list[0].details;

      })
    }
    HTMLdecode(str: any) {
      let txt = new DOMParser().parseFromString(str, "text/html");
      return txt.documentElement.textContent;
    }
    showLessThan300Character(key: any) {
      if (key.length > 280)
        return key.substring(0, 280) + ' ...';
      else
        return key;
    }
}
